import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  convertAmount,
  getAmountWithCurrency,
  toFixed,
  userInfoStore,
  useTranslation,
} from '@pascal/pascal-core';

import { doBetStore } from '../../../store';
import { globalTranslationKeys } from '../../../enums';
import crown from '../../../assets/images/game/crown.png';

export const WinPopUp = observer(() => {
  const t = useTranslation();
  const { winAmount } = doBetStore;
  const { precision = 2 } = userInfoStore;

  return (
    <div className={`pop-game-h ${winAmount ? '' : 'd-none'}`}>
      <div className='pop-game-content'>
        <div className='pop-game-img-light' />
        <div className='pop-game-ins'>
          <span className='pop-game-ins-img'>
            <img src={crown} alt='' />
          </span>
          <p className='pop-game-ins-text'>{t(globalTranslationKeys.YouWin)}</p>
          <p className='pop-game-ins-money'>{`${
            winAmount
              ? getAmountWithCurrency({
                  amount: convertAmount(Number(toFixed(winAmount, precision || 2))),
                  withSpace: true,
                })
              : ''
          }`}</p>
        </div>
      </div>
    </div>
  );
});
